import { useBreakpointValue } from '@chakra-ui/react'

export default useBreakpointValue
